import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

function Stats() {
  const { user } = useAuth();
  const [month, setMonth] = useState(new Date().toISOString().substring(0, 7));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadStats(); }, [month]);

  const loadStats = async () => {
    setLoading(true);
    if (user.role === 'admin') {
      const result = await api.getStats(month);
      if (result) setData(result);
    } else {
      const result = await api.getMyStats(month);
      if (result) setData(result);
    }
    setLoading(false);
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '40px' }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>;
  }

  // Admin Stats
  if (user.role === 'admin' && data) {
    return (
      <div className="animate-in">
        <div style={{ marginBottom: '16px' }}>
          <input type="month" value={month} onChange={e => setMonth(e.target.value)}
            style={{ background: '#2a2a2a', border: '1px solid #444', borderRadius: '10px', padding: '10px 14px', color: 'white', fontSize: '14px', outline: 'none' }} />
        </div>

        {/* Totals */}
        <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '20px', marginBottom: '16px', border: '1px solid #333' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', textAlign: 'center' }}>
            <div>
              <div style={{ fontSize: '28px', fontWeight: 800, color: '#E53E3E' }}>{data.totals?.total_days || 0}</div>
              <div style={{ fontSize: '11px', color: '#888' }}>Jours</div>
            </div>
            <div>
              <div style={{ fontSize: '28px', fontWeight: 800, color: '#3B82F6' }}>{data.totals?.total_participants || 0}</div>
              <div style={{ fontSize: '11px', color: '#888' }}>Participants</div>
            </div>
            <div>
              <div style={{ fontSize: '28px', fontWeight: 800, color: '#8B5CF6' }}>{data.totals?.total_groups || 0}</div>
              <div style={{ fontSize: '11px', color: '#888' }}>Groupes</div>
            </div>
          </div>
        </div>

        {/* Per Guide */}
        <div style={{ fontWeight: 700, fontSize: '14px', marginBottom: '10px' }}>Par guide</div>
        {(data.guides || []).map(g => (
          <div key={g.id} style={{
            background: '#1a1a1a', borderRadius: '12px', padding: '12px 14px',
            marginBottom: '6px', border: '1px solid #333',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          }}>
            <div style={{ fontWeight: 500, fontSize: '13px' }}>{g.name}</div>
            <div style={{ display: 'flex', gap: '6px' }}>
              <span style={{ background: '#064E3B', color: '#6EE7B7', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600 }}>
                {g.days_worked}j
              </span>
              <span style={{ background: '#7F1D1D', color: '#FCA5A5', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600 }}>
                {g.absences} abs
              </span>
              <span style={{ background: '#1E3A5F', color: '#60A5FA', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 600 }}>
                {g.total_participants}P
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Guide Stats
  return (
    <div className="animate-in">
      <div style={{ marginBottom: '16px' }}>
        <input type="month" value={month} onChange={e => setMonth(e.target.value)}
          style={{ background: '#2a2a2a', border: '1px solid #444', borderRadius: '10px', padding: '10px 14px', color: 'white', fontSize: '14px', outline: 'none' }} />
      </div>

      <div style={{ background: '#1a1a1a', borderRadius: '16px', padding: '24px', border: '1px solid #333' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'center' }}>
          <div>
            <div style={{ fontSize: '36px', fontWeight: 800, color: '#10B981' }}>{data?.days_worked || 0}</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Jours travaillés</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: 800, color: '#3B82F6' }}>{data?.total_participants || 0}</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Participants</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: 800, color: '#EF4444' }}>{data?.absences || 0}</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Absences</div>
          </div>
          <div>
            <div style={{ fontSize: '36px', fontWeight: 800, color: '#F59E0B' }}>{data?.incidents || 0}</div>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>Incidents</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stats;
